var map = {
	"./badge/1.png": 64422,
	"./badge/2.png": 5661,
	"./badge/3.png": 84532,
	"./badge/4.png": 30443,
	"./badge/5.png": 9314,
	"./badge/6.png": 57497,
	"./badge/7.png": 76944,
	"./badge/8.png": 27479,
	"./badge/9.png": 84462,
	"./city/1.png": 68330,
	"./city/2.png": 9409,
	"./city/3.png": 88280,
	"./city/4.png": 10423,
	"./city/5.png": 10926,
	"./city/6.png": 38757,
	"./city/7.png": 86492,
	"./city/8-old.png": 87475,
	"./city/8.png": 7883,
	"./city/9.png": 17378,
	"./encounter/old-grandfather.jpg": 7049,
	"./items/bike.png": 13959,
	"./items/bike_blue.png": 26616,
	"./items/bike_green.png": 79339,
	"./items/bike_red.png": 40107,
	"./items/bike_yellow.png": 66932,
	"./items/cap.png": 81310,
	"./items/flashlight.png": 30470,
	"./items/potion_full_heal.png": 14248,
	"./items/potion_full_heal_endangered.png": 95794,
	"./items/train_pass.png": 7270,
	"./news/catch-button-glow.png": 53963,
	"./news/dungeon-skill-used.png": 57663,
	"./news/fight-report-redesign.png": 56992,
	"./news/heal-lifesteal-preselect.png": 59001,
	"./news/language-switcher.png": 97405,
	"./news/notification-sound-catalog.png": 73846,
	"./news/pokedex-caught-glow.png": 48820,
	"./news/pokedex-redesign.png": 12349,
	"./news/pokedex-type-filter.png": 48857,
	"./news/pokemon-picker.png": 7793,
	"./news/pvp-arena.png": 97079,
	"./news/rules-mobile.png": 98115,
	"./news/skill-dialog-header.png": 6585,
	"./news/skills-table.png": 56854,
	"./news/stadium-badge.png": 41304,
	"./news/team-bottom-sheet-drag.png": 55625,
	"./news/toplist-redesign.png": 56852,
	"./news/trade-market-filters.png": 6122,
	"./news/trainer-tab.png": 31390,
	"./obstacles/Abyss.png": 71020,
	"./obstacles/Boulder.png": 53995,
	"./obstacles/Dark fog.png": 26266,
	"./obstacles/Flaming wall.png": 82662,
	"./obstacles/Ford.png": 65641,
	"./obstacles/Low battery doors.png": 75042,
	"./obstacles/Magic runes.png": 63098,
	"./obstacles/Mysterious mist.png": 35609,
	"./obstacles/Rapids.png": 85295,
	"./obstacles/Thicket.png": 96128,
	"./obstacles/Wooden roadblock.png": 95361,
	"./pokemons/1.png": 99561,
	"./pokemons/10.png": 97005,
	"./pokemons/100.png": 39257,
	"./pokemons/101.png": 23504,
	"./pokemons/102.png": 88907,
	"./pokemons/103.png": 25250,
	"./pokemons/104.png": 34397,
	"./pokemons/105.png": 96916,
	"./pokemons/106.png": 35727,
	"./pokemons/107.png": 50630,
	"./pokemons/108.png": 90433,
	"./pokemons/109.png": 17720,
	"./pokemons/11.png": 70852,
	"./pokemons/110.png": 36862,
	"./pokemons/111.png": 89351,
	"./pokemons/112.png": 86700,
	"./pokemons/113.png": 22613,
	"./pokemons/114.png": 98842,
	"./pokemons/115.png": 46595,
	"./pokemons/116.png": 9736,
	"./pokemons/117.png": 3601,
	"./pokemons/118.png": 42646,
	"./pokemons/119.png": 39583,
	"./pokemons/12.png": 84415,
	"./pokemons/120.png": 559,
	"./pokemons/121.png": 77894,
	"./pokemons/122.png": 59101,
	"./pokemons/123.png": 26068,
	"./pokemons/124.png": 75979,
	"./pokemons/125.png": 54850,
	"./pokemons/126.png": 10937,
	"./pokemons/127.png": 4688,
	"./pokemons/128.png": 24599,
	"./pokemons/129.png": 79022,
	"./pokemons/13.png": 6326,
	"./pokemons/130.png": 44484,
	"./pokemons/131.png": 24077,
	"./pokemons/132.png": 92310,
	"./pokemons/133.png": 46111,
	"./pokemons/134.png": 18080,
	"./pokemons/135.png": 42281,
	"./pokemons/136.png": 94098,
	"./pokemons/137.png": 99291,
	"./pokemons/138.png": 11628,
	"./pokemons/139.png": 23253,
	"./pokemons/14.png": 80585,
	"./pokemons/140.png": 55949,
	"./pokemons/141.png": 29796,
	"./pokemons/142.png": 43359,
	"./pokemons/143.png": 65270,
	"./pokemons/144.png": 39529,
	"./pokemons/145.png": 84704,
	"./pokemons/146.png": 39739,
	"./pokemons/147.png": 74386,
	"./pokemons/148.png": 26389,
	"./pokemons/149.png": 43500,
	"./pokemons/15.png": 25760,
	"./pokemons/150.png": 45186,
	"./pokemons/16.png": 80795,
	"./pokemons/17.png": 15442,
	"./pokemons/18.png": 67445,
	"./pokemons/19.png": 84556,
	"./pokemons/2.png": 34418,
	"./pokemons/20.png": 75112,
	"./pokemons/21.png": 89329,
	"./pokemons/22.png": 59162,
	"./pokemons/23.png": 60387,
	"./pokemons/24.png": 46572,
	"./pokemons/25.png": 15669,
	"./pokemons/26.png": 48318,
	"./pokemons/27.png": 66631,
	"./pokemons/28.png": 6048,
	"./pokemons/29.png": 77225,
	"./pokemons/3.png": 83419,
	"./pokemons/30.png": 56307,
	"./pokemons/31.png": 40746,
	"./pokemons/32.png": 81825,
	"./pokemons/33.png": 60696,
	"./pokemons/34.png": 5220,
	"./pokemons/35.png": 83342,
	"./pokemons/36.png": 11173,
	"./pokemons/37.png": 58908,
	"./pokemons/38.png": 80299,
	"./pokemons/39.png": 89794,
	"./pokemons/4.png": 89828,
	"./pokemons/40.png": 77918,
	"./pokemons/41.png": 30407,
	"./pokemons/42.png": 11404,
	"./pokemons/43.png": 63669,
	"./pokemons/44.png": 39898,
	"./pokemons/45.png": 87651,
	"./pokemons/46.png": 50792,
	"./pokemons/47.png": 44657,
	"./pokemons/48.png": 67350,
	"./pokemons/49.png": 80639,
	"./pokemons/5.png": 15981,
	"./pokemons/50.png": 80313,
	"./pokemons/51.png": 64560,
	"./pokemons/52.png": 29963,
	"./pokemons/53.png": 66306,
	"./pokemons/54.png": 81482,
	"./pokemons/55.png": 37972,
	"./pokemons/56.png": 60431,
	"./pokemons/57.png": 91686,
	"./pokemons/58.png": 31489,
	"./pokemons/59.png": 58776,
	"./pokemons/6.png": 25302,
	"./pokemons/60.png": 85540,
	"./pokemons/61.png": 48781,
	"./pokemons/62.png": 33366,
	"./pokemons/63.png": 87167,
	"./pokemons/64.png": 59136,
	"./pokemons/65.png": 83337,
	"./pokemons/66.png": 18802,
	"./pokemons/67.png": 40347,
	"./pokemons/68.png": 36332,
	"./pokemons/69.png": 47957,
	"./pokemons/7.png": 3391,
	"./pokemons/70.png": 41615,
	"./pokemons/71.png": 2598,
	"./pokemons/72.png": 157,
	"./pokemons/73.png": 67124,
	"./pokemons/74.png": 17035,
	"./pokemons/75.png": 95906,
	"./pokemons/76.png": 51993,
	"./pokemons/77.png": 45744,
	"./pokemons/78.png": 65655,
	"./pokemons/79.png": 20078,
	"./pokemons/8.png": 96840,
	"./pokemons/80.png": 76570,
	"./pokemons/81.png": 66403,
	"./pokemons/82.png": 4424,
	"./pokemons/83.png": 52817,
	"./pokemons/84.png": 8254,
	"./pokemons/85.png": 84039,
	"./pokemons/86.png": 17004,
	"./pokemons/87.png": 28629,
	"./pokemons/88.png": 99474,
	"./pokemons/89.png": 21019,
	"./pokemons/9.png": 36785,
	"./pokemons/90.png": 71109,
	"./pokemons/91.png": 88220,
	"./pokemons/92.png": 46327,
	"./pokemons/93.png": 750,
	"./pokemons/94.png": 18465,
	"./pokemons/95.png": 97336,
	"./pokemons/96.png": 43091,
	"./pokemons/97.png": 4234,
	"./pokemons/98.png": 80829,
	"./pokemons/99.png": 47796,
	"./pokemons/Alolan/1.png": 39017,
	"./pokemons/Alolan/10.png": 59501,
	"./pokemons/Alolan/100.png": 37817,
	"./pokemons/Alolan/101.png": 31568,
	"./pokemons/Alolan/102.png": 61739,
	"./pokemons/Alolan/103.png": 71234,
	"./pokemons/Alolan/104.png": 32957,
	"./pokemons/Alolan/105.png": 95476,
	"./pokemons/Alolan/106.png": 16943,
	"./pokemons/Alolan/107.png": 35398,
	"./pokemons/Alolan/108.png": 63265,
	"./pokemons/Alolan/109.png": 42136,
	"./pokemons/Alolan/109a.png": 81091,
	"./pokemons/Alolan/109b.png": 95816,
	"./pokemons/Alolan/109c.png": 93681,
	"./pokemons/Alolan/10a.png": 38432,
	"./pokemons/Alolan/11.png": 96260,
	"./pokemons/Alolan/110.png": 13406,
	"./pokemons/Alolan/110a.png": 10261,
	"./pokemons/Alolan/110b.png": 24510,
	"./pokemons/Alolan/110c.png": 76999,
	"./pokemons/Alolan/111.png": 31719,
	"./pokemons/Alolan/112.png": 11660,
	"./pokemons/Alolan/113.png": 80757,
	"./pokemons/Alolan/114.png": 24250,
	"./pokemons/Alolan/115.png": 41827,
	"./pokemons/Alolan/115a.png": 4786,
	"./pokemons/Alolan/116.png": 56552,
	"./pokemons/Alolan/117.png": 54417,
	"./pokemons/Alolan/118.png": 42486,
	"./pokemons/Alolan/119.png": 38815,
	"./pokemons/Alolan/11a.png": 62583,
	"./pokemons/Alolan/12.png": 81535,
	"./pokemons/Alolan/120.png": 41871,
	"./pokemons/Alolan/120a.png": 93126,
	"./pokemons/Alolan/121.png": 73126,
	"./pokemons/Alolan/121a.png": 15661,
	"./pokemons/Alolan/122.png": 40541,
	"./pokemons/Alolan/123.png": 19412,
	"./pokemons/Alolan/123a.png": 84615,
	"./pokemons/Alolan/124.png": 11403,
	"./pokemons/Alolan/125.png": 47746,
	"./pokemons/Alolan/126.png": 61753,
	"./pokemons/Alolan/127.png": 46000,
	"./pokemons/Alolan/128.png": 19831,
	"./pokemons/Alolan/129.png": 29838,
	"./pokemons/Alolan/129a.png": 43589,
	"./pokemons/Alolan/129b.png": 71790,
	"./pokemons/Alolan/12a.png": 99734,
	"./pokemons/Alolan/12b.png": 81357,
	"./pokemons/Alolan/13.png": 44086,
	"./pokemons/Alolan/130.png": 8868,
	"./pokemons/Alolan/130a.png": 16695,
	"./pokemons/Alolan/130b.png": 9116,
	"./pokemons/Alolan/131.png": 62765,
	"./pokemons/Alolan/131a.png": 30912,
	"./pokemons/Alolan/132.png": 48790,
	"./pokemons/Alolan/137.png": 72731,
	"./pokemons/Alolan/14.png": 94057,
	"./pokemons/Alolan/143.png": 88790,
	"./pokemons/Alolan/143a.png": 9181,
	"./pokemons/Alolan/15.png": 69856,
	"./pokemons/Alolan/16.png": 51067,
	"./pokemons/Alolan/17.png": 29522,
	"./pokemons/Alolan/18.png": 58677,
	"./pokemons/Alolan/19.png": 47052,
	"./pokemons/Alolan/2.png": 90834,
	"./pokemons/Alolan/20.png": 45832,
	"./pokemons/Alolan/21.png": 85777,
	"./pokemons/Alolan/22.png": 61114,
	"./pokemons/Alolan/23.png": 82691,
	"./pokemons/Alolan/23a.png": 19346,
	"./pokemons/Alolan/24.png": 52524,
	"./pokemons/Alolan/24a.png": 65807,
	"./pokemons/Alolan/25.png": 35413,
	"./pokemons/Alolan/26.png": 49662,
	"./pokemons/Alolan/27.png": 20999,
	"./pokemons/Alolan/28.png": 93728,
	"./pokemons/Alolan/29.png": 48553,
	"./pokemons/Alolan/3.png": 12379,
	"./pokemons/Alolan/30.png": 21363,
	"./pokemons/Alolan/31.png": 66154,
	"./pokemons/Alolan/32.png": 15137,
	"./pokemons/Alolan/33.png": 30520,
	"./pokemons/Alolan/34.png": 22039,
	"./pokemons/Alolan/35.png": 56641,
	"./pokemons/Alolan/36.png": 50821,
	"./pokemons/Alolan/37.png": 21404,
	"./pokemons/Alolan/37a.png": 11039,
	"./pokemons/Alolan/38.png": 25003,
	"./pokemons/Alolan/38a.png": 33226,
	"./pokemons/Alolan/39.png": 3874,
	"./pokemons/Alolan/39a.png": 48657,
	"./pokemons/Alolan/4.png": 57572,
	"./pokemons/Alolan/40.png": 68702,
	"./pokemons/Alolan/40a.png": 25429,
	"./pokemons/Alolan/41.png": 87015,
	"./pokemons/Alolan/42.png": 50604,
	"./pokemons/Alolan/43.png": 36053,
	"./pokemons/Alolan/44.png": 79546,
	"./pokemons/Alolan/45.png": 80771,
	"./pokemons/Alolan/46.png": 95496,
	"./pokemons/Alolan/47.png": 9713,
	"./pokemons/Alolan/48.png": 81430,
	"./pokemons/Alolan/49.png": 77759,
	"./pokemons/Alolan/5.png": 20813,
	"./pokemons/Alolan/50.png": 93113,
	"./pokemons/Alolan/51.png": 86864,
	"./pokemons/Alolan/52.png": 683,
	"./pokemons/Alolan/53.png": 10178,
	"./pokemons/Alolan/53a.png": 75313,
	"./pokemons/Alolan/54.png": 71901,
	"./pokemons/Alolan/54a.png": 53744,
	"./pokemons/Alolan/55.png": 50772,
	"./pokemons/Alolan/55a.png": 82215,
	"./pokemons/Alolan/56.png": 55887,
	"./pokemons/Alolan/57.png": 90694,
	"./pokemons/Alolan/58.png": 2209,
	"./pokemons/Alolan/58a.png": 25372,
	"./pokemons/Alolan/58b.png": 26007,
	"./pokemons/Alolan/59.png": 81080,
	"./pokemons/Alolan/59a.png": 79907,
	"./pokemons/Alolan/59b.png": 94632,
	"./pokemons/Alolan/6.png": 89046,
	"./pokemons/Alolan/60.png": 47812,
	"./pokemons/Alolan/60a.png": 31863,
	"./pokemons/Alolan/61.png": 18061,
	"./pokemons/Alolan/61a.png": 29728,
	"./pokemons/Alolan/62.png": 87734,
	"./pokemons/Alolan/62a.png": 50877,
	"./pokemons/Alolan/63.png": 1023,
	"./pokemons/Alolan/64.png": 49696,
	"./pokemons/Alolan/65.png": 27817,
	"./pokemons/Alolan/66.png": 96850,
	"./pokemons/Alolan/67.png": 28027,
	"./pokemons/Alolan/68.png": 31788,
	"./pokemons/Alolan/69.png": 84053,
	"./pokemons/Alolan/7.png": 42847,
	"./pokemons/Alolan/70.png": 80815,
	"./pokemons/Alolan/71.png": 12070,
	"./pokemons/Alolan/72.png": 79485,
	"./pokemons/Alolan/73.png": 58356,
	"./pokemons/Alolan/74.png": 50347,
	"./pokemons/Alolan/75.png": 86690,
	"./pokemons/Alolan/76.png": 697,
	"./pokemons/Alolan/77.png": 84944,
	"./pokemons/Alolan/77a.png": 8619,
	"./pokemons/Alolan/78.png": 58775,
	"./pokemons/Alolan/78a.png": 85054,
	"./pokemons/Alolan/79.png": 85134,
	"./pokemons/Alolan/8.png": 95784,
	"./pokemons/Alolan/80.png": 24602,
	"./pokemons/Alolan/81.png": 88707,
	"./pokemons/Alolan/82.png": 51848,
	"./pokemons/Alolan/83.png": 45713,
	"./pokemons/Alolan/84.png": 78974,
	"./pokemons/Alolan/85.png": 31463,
	"./pokemons/Alolan/86.png": 12460,
	"./pokemons/Alolan/87.png": 64725,
	"./pokemons/Alolan/88.png": 77522,
	"./pokemons/Alolan/89.png": 8699,
	"./pokemons/Alolan/9.png": 27825,
	"./pokemons/Alolan/90.png": 68229,
	"./pokemons/Alolan/91.png": 50716,
	"./pokemons/Alolan/92.png": 39447,
	"./pokemons/Alolan/93.png": 65806,
	"./pokemons/Alolan/94.png": 32545,
	"./pokemons/Alolan/95.png": 59832,
	"./pokemons/Alolan/96.png": 34323,
	"./pokemons/Alolan/96a.png": 3938,
	"./pokemons/Alolan/97.png": 83562,
	"./pokemons/Alolan/97a.png": 99785,
	"./pokemons/Alolan/98.png": 60157,
	"./pokemons/Alolan/99.png": 39028,
	"./pokemons/Alolan/99a.png": 59655,
	"./position/DUNGEON.png": 86865,
	"./position/DUNGEON_WIN.png": 40426,
	"./position/DUNGEON_WIN3.png": 48395,
	"./position/FIGHT.png": 6477,
	"./position/FIGHT_BIOMS/WILD_CAVE.png": 3999,
	"./position/FIGHT_BIOMS/WILD_FACTORY.png": 99936,
	"./position/FIGHT_BIOMS/WILD_FOREST.png": 84455,
	"./position/FIGHT_BIOMS/WILD_MOUNTAINS.png": 28798,
	"./position/FIGHT_BIOMS/WILD_NEUTRAL.png": 143,
	"./position/FIGHT_BIOMS/WILD_PLAINS.png": 20339,
	"./position/FIGHT_BIOMS/WILD_RIVER.png": 52964,
	"./position/FIGHT_BIOMS/WILD_RUINS.png": 93067,
	"./position/FIGHT_BIOMS/WILD_SEA.png": 81731,
	"./position/FIGHT_BIOMS/WILD_TROPIC.png": 10203,
	"./position/FIGHT_BIOMS/WILD_VULCAN.png": 17561,
	"./position/FIGHT_TRAINER.png": 73975,
	"./position/FIGHT_TRAINER_WIN.png": 82772,
	"./position/LEAGUE_FIGHT-old.png": 75895,
	"./position/LEAGUE_FIGHT.png": 88751,
	"./position/MEWTWO_FIGHT.png": 75321,
	"./position/MEWTWO_FIGHT_QIN.png": 44536,
	"./position/OBSTACLE_FIGHT.png": 76571,
	"./position/START.png": 17203,
	"./position/TEAM_ROCKET.png": 72305,
	"./position/TRAINER_FIGHT_WILD.png": 22616,
	"./position/WILD_TROPIC2.png": 40325,
	"./position/thumb/DUNGEON.png": 74648,
	"./pvp/battlefield-forest.jpg": 91478,
	"./pvp/battlefield-pvp-liga.jpg": 57911,
	"./rank/rank-1.png": 41606,
	"./rank/rank-2.png": 82845,
	"./rank/rank-3.png": 45364,
	"./rank/rank-4.png": 7627,
	"./rank/rank-5.png": 86498,
	"./rank/rank-6.png": 34681,
	"./rank/rank-7.png": 37776,
	"./rank/rank-8.png": 88311,
	"./roads/1.png": 60658,
	"./roads/2.png": 75273,
	"./roads/3.png": 97152,
	"./roads/4.png": 48479,
	"./roads/5.png": 51542,
	"./roads/6.png": 65517,
	"./roads/7.png": 11620,
	"./roads/8.png": 55491,
	"./roads/9.png": 7738,
	"./roads/komprimovane/1.png": 72529,
	"./roads/komprimovane/2.png": 51418,
	"./roads/komprimovane/3.png": 15523,
	"./roads/komprimovane/4.png": 39276,
	"./roads/komprimovane/5.png": 91541,
	"./roads/komprimovane/6.png": 5790,
	"./roads/komprimovane/7.png": 58279,
	"./roads/komprimovane/8.png": 57184,
	"./roads/komprimovane/9.png": 35305,
	"./rules/badges.png": 14219,
	"./rules/screenshot-obstacle.png": 23653,
	"./rules/screenshot-pokedex.png": 20054,
	"./rules/screenshot-trainer.png": 61899,
	"./stadion/1.png": 46171,
	"./stadion/2.png": 67840,
	"./stadion/3.png": 22665,
	"./stadion/4.png": 22838,
	"./stadion/5.png": 19167,
	"./stadion/6.png": 64516,
	"./stadion/7.png": 4461,
	"./stadion/8.png": 4602,
	"./stadion/gyms/1.png": 5012,
	"./stadion/gyms/2.png": 23919,
	"./stadion/gyms/3.png": 1254,
	"./stadion/gyms/4.png": 94329,
	"./stadion/gyms/5.png": 97424,
	"./stadion/gyms/6.png": 50923,
	"./stadion/gyms/7.png": 29794,
	"./stadion/gyms/8.png": 76741,
	"./stones/BUG.png": 97834,
	"./stones/DARK.png": 89774,
	"./stones/DRAGON.png": 65171,
	"./stones/ELECTRIC.png": 18775,
	"./stones/FIGHTING.png": 32952,
	"./stones/FIRE.png": 96138,
	"./stones/FLYING.png": 87007,
	"./stones/GHOST.png": 60445,
	"./stones/GRASS.png": 37850,
	"./stones/GROUND.png": 84499,
	"./stones/ICE.png": 34725,
	"./stones/NORMAL.png": 58899,
	"./stones/POISON.png": 46618,
	"./stones/PSYCHIC.png": 29169,
	"./stones/ROCK.png": 63913,
	"./stones/STEEL.png": 32289,
	"./stones/ULTIMATE.png": 67707,
	"./stones/WATER.png": 89441,
	"./trainer/1.png": 67908,
	"./trainer/2.png": 53183,
	"./trainer/3.png": 99382,
	"./trainer/4.png": 65705,
	"./trainer/5.png": 41504,
	"./trainer/6.png": 22715,
	"./trainer/7.png": 1170,
	"./trainer/8.png": 30325,
	"./trainer/9.png": 18700,
	"./trainer/Amber.png": 1288,
	"./trainer/Apn.png": 26498,
	"./trainer/Ash Ketchum.png": 38922,
	"./trainer/Babli.png": 44091,
	"./trainer/Bianca.png": 23703,
	"./trainer/Black.png": 66920,
	"./trainer/Bob.png": 59592,
	"./trainer/Borek.png": 24148,
	"./trainer/Brian.png": 2309,
	"./trainer/Broruto.png": 30466,
	"./trainer/Calem.png": 81635,
	"./trainer/Calus.png": 97677,
	"./trainer/Carmen.png": 68979,
	"./trainer/Cinciri.png": 13208,
	"./trainer/Clemont.png": 78897,
	"./trainer/Cody.png": 29454,
	"./trainer/Dawn.png": 89563,
	"./trainer/Diana.png": 55836,
	"./trainer/Ethan.png": 86161,
	"./trainer/Ferguson.png": 3108,
	"./trainer/Fines.png": 43302,
	"./trainer/Fleur.png": 45331,
	"./trainer/Frostylina.png": 21400,
	"./trainer/Fuflin.png": 6105,
	"./trainer/Gerta.png": 18502,
	"./trainer/Ginger.png": 25529,
	"./trainer/Gladion.png": 25961,
	"./trainer/Gloria.png": 36389,
	"./trainer/Gotsu.png": 19111,
	"./trainer/Hector.png": 72942,
	"./trainer/Hilbert.png": 54899,
	"./trainer/Hilda.png": 74131,
	"./trainer/Jezz.png": 15450,
	"./trainer/Jimmy.png": 76835,
	"./trainer/Jonathan.png": 19662,
	"./trainer/Ketchy.png": 27903,
	"./trainer/Kris.png": 34690,
	"./trainer/Kyra.png": 50506,
	"./trainer/Lana.png": 25107,
	"./trainer/Leaf.png": 90253,
	"./trainer/Lillie.png": 74674,
	"./trainer/Lucas.png": 52797,
	"./trainer/Lyra.png": 33135,
	"./trainer/Mallow.png": 57153,
	"./trainer/Mangetino.png": 31365,
	"./trainer/May.png": 6666,
	"./trainer/Methan.png": 53190,
	"./trainer/Metsu.png": 13535,
	"./trainer/Moon.png": 70898,
	"./trainer/Nadja.png": 74207,
	"./trainer/Nate.png": 40123,
	"./trainer/Patricia.png": 61804,
	"./trainer/Polly.png": 86301,
	"./trainer/Pomi.png": 18748,
	"./trainer/Prophan.png": 60025,
	"./trainer/Pupin.png": 4215,
	"./trainer/Red.png": 20348,
	"./trainer/Ringo.png": 57760,
	"./trainer/Rosa.png": 92620,
	"./trainer/Saffire.png": 77907,
	"./trainer/Serena.png": 89885,
	"./trainer/Sky.png": 10374,
	"./trainer/Summer.png": 67706,
	"./trainer/Sussy.png": 39278,
	"./trainer/Trin.png": 97586,
	"./trainer/Volty.png": 81303,
	"./trainer/Yam.png": 90218,
	"./trainer/Zu.png": 85146,
	"./trainer/league/Adiha.png": 57494,
	"./trainer/league/Agent Smith.png": 78377,
	"./trainer/league/Alex.png": 22403,
	"./trainer/league/Anton.png": 2479,
	"./trainer/league/Beilin.png": 6330,
	"./trainer/league/Bizika.png": 32151,
	"./trainer/league/Blizzy.png": 27071,
	"./trainer/league/Boban.png": 53851,
	"./trainer/league/Bred.png": 28652,
	"./trainer/league/Bubla.png": 28005,
	"./trainer/league/Colora.png": 51141,
	"./trainer/league/Davison.png": 87045,
	"./trainer/league/Derik.png": 15414,
	"./trainer/league/Donovan.png": 20446,
	"./trainer/league/Dony.png": 10367,
	"./trainer/league/Dr. Raven.png": 15645,
	"./trainer/league/Edudant.png": 63768,
	"./trainer/league/Fan Zang.png": 656,
	"./trainer/league/Farmer Tom.png": 49206,
	"./trainer/league/Francimore.png": 39949,
	"./trainer/league/Fykis.png": 83405,
	"./trainer/league/Gejedli.png": 66099,
	"./trainer/league/Ghost Henry.png": 55468,
	"./trainer/league/Giruga.png": 88956,
	"./trainer/league/Gorogo.png": 90390,
	"./trainer/league/Graundy.png": 76195,
	"./trainer/league/Ha Jajan.png": 20720,
	"./trainer/league/Hala.png": 4567,
	"./trainer/league/Heidy.png": 77584,
	"./trainer/league/Helico.png": 9293,
	"./trainer/league/Hontenten.png": 74926,
	"./trainer/league/Hó Fušihó.png": 38004,
	"./trainer/league/Izaak.png": 99053,
	"./trainer/league/Jeager.png": 5001,
	"./trainer/league/Kahid.png": 22196,
	"./trainer/league/Kelvin.png": 41468,
	"./trainer/league/Kemil.png": 85441,
	"./trainer/league/Kevin.png": 23952,
	"./trainer/league/Lemerd.png": 15722,
	"./trainer/league/Lemred.png": 62368,
	"./trainer/league/Lenore.png": 71272,
	"./trainer/league/Lulan.png": 30913,
	"./trainer/league/Mindezeen.png": 68212,
	"./trainer/league/Mindireen.png": 91000,
	"./trainer/league/Mr. Gardenier.png": 30035,
	"./trainer/league/Nemo.png": 21340,
	"./trainer/league/Olaf.png": 70971,
	"./trainer/league/Olda.png": 32711,
	"./trainer/league/Piny.png": 44709,
	"./trainer/league/Pof. Jožko.png": 66479,
	"./trainer/league/Rebeca.png": 59079,
	"./trainer/league/Red Baron.png": 73282,
	"./trainer/league/Rowan.png": 75930,
	"./trainer/league/Rubla.png": 68981,
	"./trainer/league/Shadow.png": 80559,
	"./trainer/league/Silver.png": 48232,
	"./trainer/league/Sir Marquis.png": 49271,
	"./trainer/league/Swift.png": 96370,
	"./trainer/league/Tentanten.png": 112,
	"./trainer/league/Tentari.png": 78084,
	"./trainer/league/Tyson.png": 75516,
	"./trainer/league/Walter.png": 29618,
	"./trainer/league/Weird Bob.png": 30809,
	"./trainer/league/Zabu.png": 13459,
	"./trainer/league/Činčiro.png": 67029,
	"./trainer/players/default0.png": 64785,
	"./trainer/players/default1.png": 70920,
	"./trainer/players/default10.png": 39130,
	"./trainer/players/default11.png": 56707,
	"./trainer/players/default12.png": 55080,
	"./trainer/players/default13.png": 69297,
	"./trainer/players/default14.png": 28286,
	"./trainer/players/default15.png": 46599,
	"./trainer/players/default16.png": 26540,
	"./trainer/players/default17.png": 95637,
	"./trainer/players/default18.png": 66482,
	"./trainer/players/default19.png": 64347,
	"./trainer/players/default2.png": 7779,
	"./trainer/players/default20.png": 9931,
	"./trainer/players/default21.png": 46274,
	"./trainer/players/default22.png": 60281,
	"./trainer/players/default23.png": 44528,
	"./trainer/players/default24.png": 40399,
	"./trainer/players/default25.png": 71654,
	"./trainer/players/default26.png": 55421,
	"./trainer/players/default27.png": 17940,
	"./trainer/players/default28.png": 13235,
	"./trainer/players/default29.png": 62474,
	"./trainer/players/default3.png": 60026,
	"./trainer/players/default30.png": 9280,
	"./trainer/players/default31.png": 87401,
	"./trainer/players/default32.png": 72786,
	"./trainer/players/default33.png": 87611,
	"./trainer/players/default34.png": 23748,
	"./trainer/players/default35.png": 77645,
	"./trainer/players/default36.png": 47318,
	"./trainer/players/default37.png": 60607,
	"./trainer/players/default38.png": 30760,
	"./trainer/players/default39.png": 24625,
	"./trainer/players/default4.png": 83797,
	"./trainer/players/default40.png": 55025,
	"./trainer/players/default41.png": 15080,
	"./trainer/players/default42.png": 51939,
	"./trainer/players/default43.png": 46714,
	"./trainer/players/default44.png": 4661,
	"./trainer/players/default45.png": 21772,
	"./trainer/players/default46.png": 6599,
	"./trainer/players/default47.png": 18910,
	"./trainer/players/default48.png": 17801,
	"./trainer/players/default5.png": 47884,
	"./trainer/players/default6.png": 50535,
	"./trainer/players/default7.png": 98046,
	"./trainer/players/default8.png": 27561,
	"./trainer/players/default9.png": 49440,
	"./trainer/teamRocket/Archer.png": 53894,
	"./trainer/teamRocket/Ariana.png": 82219,
	"./trainer/teamRocket/Butch.png": 8959,
	"./trainer/teamRocket/Cassidy.png": 59129,
	"./trainer/teamRocket/James.png": 45239,
	"./trainer/teamRocket/Jessie.png": 32268,
	"./trainer/teamRocket/Meowth.png": 69131,
	"./trainer/teamRocket/Orm.png": 69907,
	"./trainer/teamRocket/Petrel.png": 74051,
	"./trainer/teamRocket/Proton.png": 76243,
	"./undefined.jpg": 25871,
	"./undefined.png": 49919,
	"./web/Meowth_portret.png": 32477,
	"./web/Officer_Jenny.png": 90971,
	"./web/Officer_Jenny_avatar.png": 68775,
	"./web/boty.gif": 74577,
	"./web/brock_suspicious.png": 35883,
	"./web/call_oak.png": 68368,
	"./web/day.png": 44326,
	"./web/footprints.png": 86226,
	"./web/forest.png": 67977,
	"./web/gym.png": 68793,
	"./web/heal-lifesteal.gif": 61103,
	"./web/hit-impact.gif": 51711,
	"./web/league_stadion.png": 45188,
	"./web/lose.png": 16337,
	"./web/masterball.png": 42251,
	"./web/mewtwo.png": 43327,
	"./web/mewtwo_chalenge.png": 13419,
	"./web/mirror-pok.png": 20870,
	"./web/nurse-joy-heal-frozen.png": 4652,
	"./web/nurse-joy-heal.gif": 65012,
	"./web/oak.png": 89711,
	"./web/oak_avatar.png": 56555,
	"./web/oak_teaching.png": 70285,
	"./web/oaks_house.png": 78233,
	"./web/options_hint.png": 99464,
	"./web/pierce-pok.png": 47651,
	"./web/poison-drops.gif": 31432,
	"./web/pokeball.png": 48882,
	"./web/pokeball_catching.gif": 61227,
	"./web/pokeball_choose.png": 32676,
	"./web/pokeball_leave.png": 44946,
	"./web/pokecenter.png": 61158,
	"./web/registration.png": 87545,
	"./web/registration_joy.png": 12134,
	"./web/road.png": 1456,
	"./web/road2.png": 81472,
	"./web/shield-pok.png": 62184,
	"./web/stunned.gif": 60082,
	"./web/thumb/league_stadion.png": 80043,
	"./web/travel/nurse-joy.png": 10177,
	"./web/travel/ship-station.png": 19194,
	"./web/travel/train-station-city.png": 93012,
	"./web/travel/train-station-town.png": 24301,
	"./web/trophy.png": 84108,
	"./web/vs_swords.png": 10410,
	"./web/wild.png": 87398,
	"./web/win.png": 1666,
	"./wild/CAVE.png": 29583,
	"./wild/CAVE2.png": 65261,
	"./wild/DUNGEON.png": 29952,
	"./wild/FACTORY.png": 15184,
	"./wild/FOREST.png": 59319,
	"./wild/MOUNTAINS.png": 83726,
	"./wild/NEUTRAL.png": 1887,
	"./wild/PLAINS.png": 41635,
	"./wild/RIVER.png": 25684,
	"./wild/RUINS.png": 72571,
	"./wild/SEA.png": 4563,
	"./wild/TROPIC.png": 84971,
	"./wild/VULCAN.png": 30249,
	"./wild/thumb/CAVE.png": 39044,
	"./wild/thumb/CAVE2.png": 99564,
	"./wild/thumb/DUNGEON.png": 60981,
	"./wild/thumb/FACTORY.png": 55073,
	"./wild/thumb/FOREST.png": 88512,
	"./wild/thumb/MOUNTAINS.png": 99963,
	"./wild/thumb/NEUTRAL.png": 15742,
	"./wild/thumb/PLAINS.png": 2956,
	"./wild/thumb/RIVER.png": 88277,
	"./wild/thumb/RUINS.png": 17266,
	"./wild/thumb/SEA.png": 51854,
	"./wild/thumb/TROPIC.png": 79092,
	"./wild/thumb/VULCAN.png": 44766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32119;